module.exports = __webpack_public_path__ + "img/7.0_News_1_Funding-Announcement@2x.b438c88045625d6682c58055d56a69f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.0_News_1_Funding-Announcement@2x.png
// module id = 796
// module chunks = 0